import { useRef } from "react";
import { T } from "../tokens";
export default function Bokeh({ count = 18, style = {} }) {
  const dots = useRef(Array.from({ length: count }, () => ({
    x: Math.random() * 100, y: Math.random() * 100,
    r: 2 + Math.random() * 7, o: 0.04 + Math.random() * 0.14,
    dur: 3 + Math.random() * 4, delay: Math.random() * 3,
  })));
  return (
    <div style={{ position:"absolute", inset:0, pointerEvents:"none", overflow:"hidden", zIndex:0, ...style }}>
      {dots.current.map((b,i) => (
        <div key={i} style={{ position:"absolute", left:`${b.x}%`, top:`${b.y}%`, width:b.r*2, height:b.r*2, borderRadius:"50%", background:T.gold, opacity:b.o, animation:`fyzBokeh ${b.dur}s ${b.delay}s ease-in-out infinite alternate` }}/>
      ))}
    </div>
  );
}
